// let gTranslateLoaded = false;

// export function loadGTranslate() {
//   if (gTranslateLoaded) return;
//   gTranslateLoaded = true;

//   (window as any).gtranslateSettings = {
//     default_language: "en",
//     detect_browser_language: true,
//     languages: ["en", "fr", "ar", "pt"],
//     wrapper_selector: "#gtranslate_wrapper",
//     switcher_horizontal_position: "inline",
//     switcher_open_direction: "top",
//   };

//   const script = document.createElement("script");
//   script.src = "https://cdn.gtranslate.net/widgets/latest/dwf.js";
//   script.defer = true;
//   document.body.appendChild(script);
// }

let gTranslateLoaded = false;

export const loadGTranslate = () => {
  if (gTranslateLoaded) return;
  if (typeof window === "undefined") return;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const gWindow = window as any;

  gWindow.gtranslateSettings = {
    default_language: "en",
    detect_browser_language: true,
    languages: ["en", "fr", "ar", "pt"],
    wrapper_selector: ".gtranslate_wrapper",
    switcher_horizontal_position: "inline",
    switcher_open_direction: "top",
  };

  const script = document.createElement("script");
  script.src = "https://cdn.gtranslate.net/widgets/latest/dwf.js";
  script.async = true;
  script.id = "gtranslate-script";

  document.body.appendChild(script);

  gTranslateLoaded = true;
};